"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileFilterButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const context_1 = require("../context");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon/MosaicIcon");
const MobileFilterButton = () => {
    const { selectedFilterOptionsCount, filters, setIsMobileFiltersOpen, dictionary } = (0, context_1.useSearchResultContext)();
    if (filters.length === 0) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)("button", { className: "w-full bg-fill-primary px-md! font-regular border-primary text-icon-primary hover:bg-fill-primary-hovered active:bg-fill-primary-pressed disabled:border-disabled disabled:text-icon-disabled md:hidden flex h-[44px] items-center justify-center rounded-2xl border mb-6", onClick: () => setIsMobileFiltersOpen(true), children: [dictionary.filterBtnLabel, "\u00A0", selectedFilterOptionsCount > 0 && (0, jsx_runtime_1.jsxs)("span", { children: ["(", selectedFilterOptionsCount, ")"] }), (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "tune-outline", className: "ml-2xs" })] }));
};
exports.MobileFilterButton = MobileFilterButton;
